module.exports = __webpack_public_path__ + "img/pro32.a7903319.svg";